import snakeCase from 'lodash/snakeCase'

/**
 * Formats brand names for consistent Google Analytics tracking.
 *
 * @returns {string} A standardized brand name in snake_case or specific format.
 *
 * @description This composable converts the current website's brand to a consistent
 * format for Google Analytics tracking. It handles special cases for specific brands
 * and defaults to a generic group brand.
 *
 * @example
 * // Returns 'armani_group' for global website
 * const brand = useGAFormattedBrands()
 *
 * @example
 * // Returns 'EA7' for EA7 website
 * const brand = useGAFormattedBrands()
 */
export const useGAFormattedBrands = () => {
  const { currentWebsite: currentWebsiteToFormat } = useWebsite()

  // Default brand if no specific website is selected
  let formattedBrand = 'armani_group'

  // Format brand based on current website
  switch (currentWebsiteToFormat.value) {
    case 'ea7':
      // Special case for EA7 brand
      formattedBrand = 'EA7'
      break
    case undefined:
    case 'global':
      // Default to Armani Group for global or undefined websites
      formattedBrand = 'armani_group'
      break

    default:
      // Convert other website values to snake_case
      formattedBrand = snakeCase(currentWebsiteToFormat.value)
      break
  }
  return formattedBrand
}
